import { useRef, useState } from "react";
import { Eraser } from "lucide-react";

// On-screen signature capture pad (mouse + touch). Emits a PNG data-URL via onChange.
export default function SignaturePad({ onChange, label = "SIGN HERE" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  const ctx = () => {
    const cv = ref.current;
    const g = cv.getContext("2d");
    g.lineWidth = 2.2;
    g.lineCap = "round";
    g.lineJoin = "round";
    g.strokeStyle = "#1a2f6e";
    return g;
  };
  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return [(p.clientX - r.left) * (ref.current.width / r.width),
            (p.clientY - r.top) * (ref.current.height / r.height)];
  };
  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const [x, y] = pos(e);
    const g = ctx();
    g.beginPath();
    g.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const [x, y] = pos(e);
    const g = ctx();
    g.lineTo(x, y);
    g.stroke();
    if (empty) setEmpty(false);
  };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange?.(empty ? "" : ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const cv = ref.current;
    cv.getContext("2d").clearRect(0, 0, cv.width, cv.height);
    setEmpty(true);
    onChange?.("");
  };

  return (
    <div data-testid="signature-pad">
      <div className="relative border-2 border-dashed rounded-sm bg-white" style={{ borderColor: "#9db4ce" }}>
        <canvas ref={ref} width={560} height={140} className="w-full h-[110px] touch-none cursor-crosshair"
          data-testid="signature-canvas"
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
        {empty && (
          <span className="absolute inset-0 flex items-center justify-center pointer-events-none font-mono text-[11px] tracking-widest text-[#9db4ce]">
            ✕ {label}
          </span>
        )}
        <span className="absolute left-3 right-3 bottom-4 border-b pointer-events-none" style={{ borderColor: "#c9d6e4" }} />
      </div>
      <button type="button" data-testid="signature-clear" onClick={clear}
        className="mt-1 flex items-center gap-1 font-mono text-[10px] text-[#7d9bc1] hover:text-[#1d5d90]">
        <Eraser size={11} /> CLEAR SIGNATURE
      </button>
    </div>
  );
}
